import { isIosAppSignInFlowPage } from '../util/appSignIn';

/**
 * Wraps a Sentry transport factory (`Sentry.makeFetchTransport`) so that nothing reaches Sentry
 * while the page is part of the Medsender iOS app's sign-in (isIosAppSignInFlowPage: its printer
 * sign-in page, and the login, Forgot password and Microsoft sign-in return on their way to it).
 * Gibraltar's sign-in pages report as every other page does.
 *
 * The page is checked for each envelope at the moment it is sent, so this drops every kind of
 * envelope: error events and `captureMessage` diagnostics, the release-health session pings that
 * the default browserSessionIntegration sends on page load and navigation, and client reports.
 * `beforeSend` sees only events, so it could not do this. Once the page is an ordinary one again,
 * envelopes are sent as before.
 *
 * @param {Function} makeTransport a Sentry transport factory
 * @param {Function} currentLocation returns the page's location (tests pass their own)
 * @returns {Function} a Sentry transport factory
 */
export const withoutAppSignInPages = (
  makeTransport,
  currentLocation = () => window.location,
) => (options) => {
  const transport = makeTransport(options);
  return {
    ...transport,
    send: (envelope) => (
      isIosAppSignInFlowPage(currentLocation()) ? Promise.resolve({}) : transport.send(envelope)
    ),
  };
};

export default withoutAppSignInPages;
